import { useCallback } from 'react'
import { useAuth } from 'react-oidc-context'
import { Navigate } from 'react-router-dom'
import { useTimeout } from 'usehooks-ts'
import urls from '@app/routes/urls'
import { useAppDispatch } from '@app/store/hooks'
import { addAlert } from '@app/store/slices/alerts'

const AuthLogout = () => {
  const auth = useAuth()
  const dispatch = useAppDispatch()

  const logout = useCallback(async () => {
    try {
      if (auth.isAuthenticated) {
        await auth.removeUser()
        await auth.revokeTokens()
        await auth.signoutSilent({
          id_token_hint: auth.user?.id_token,
        })
        await auth.clearStaleState()
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Logout failed', err)
      dispatch(addAlert({ message: 'Failed to logout', variant: 'error', expiresAfter: 5000 }))
    }
  }, [auth, dispatch])

  useTimeout(logout, 1000)

  if (!auth.isAuthenticated) {
    return <Navigate to={urls.root} />
  }

  return (
    <div>
      <h4>Signing out...</h4>
    </div>
  )
}

export default AuthLogout
